import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_REQUEST = 'apiPartner/FETCH_REQUEST'
const FETCH_LIST_SUCCESS = 'apiPartner/FETCH_LIST_SUCCESS'
const FETCH_PARTNER_SUCCESS = 'apiPartner/FETCH_PARTNER_SUCCESS'
const FETCH_PUSH_TEMPLATE_SUCCESS = 'apiPartner/FETCH_PUSH_TEMPLATE_SUCCESS'
const FETCH_HELPER_SUCCESS = 'apiPartner/FETCH_HELPER_SUCCESS'
const FETCH_FAILURE = 'apiPartner/FETCH_FAILURE'

const MUTATE_REQUEST = 'apiPartner/MUTATE_REQUEST'
const MUTATE_SUCCESS = 'apiPartner/MUTATE_SUCCESS'
const MUTATE_FAILURE = 'apiPartner/MUTATE_FAILURE'

const initialState = {
  isLoading: false,
  error: {},
  partnerList: [],
  partner: {},
  pushTemplateList: [],
  helperList: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REQUEST:
    case MUTATE_REQUEST:
      return { ...state, isLoading: true }
    case FETCH_LIST_SUCCESS:
      return { ...state, isLoading: false, partnerList: action.payload }
    case FETCH_PARTNER_SUCCESS:
      return { ...state, isLoading: false, partner: action.payload }
    case FETCH_PUSH_TEMPLATE_SUCCESS:
      return { ...state, isLoading: false, pushTemplateList: action.payload }
    case FETCH_HELPER_SUCCESS:
      return { ...state, isLoading: false, helperList: action.payload }
    case MUTATE_SUCCESS:
      return { ...state, isLoading: false }
    case FETCH_FAILURE:
    case MUTATE_FAILURE:
      return { ...state, isLoading: false, error: action.error }
    default:
      return state
  }
}

const showBackendError = (error) => {
  const backendMessage =
    error.response && error.response.data && error.response.data.message
  message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
}

const fetch = (url, successType) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_REQUEST })
      const response = await API.get(url)
      dispatch({ type: successType, payload: response.data })
    } catch (error) {
      showBackendError(error)
      dispatch({ type: FETCH_FAILURE })
    }
  }
}

// คืน true เมื่อสำเร็จ ให้หน้าจอปิด modal / โหลดรายการใหม่เอง
const mutate = (request) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MUTATE_REQUEST })
      await request()
      dispatch({ type: MUTATE_SUCCESS })
      return true
    } catch (error) {
      showBackendError(error)
      dispatch({ type: MUTATE_FAILURE })
      return false
    }
  }
}

// ---------- partner ----------

export const getPartnerList = () =>
  fetch(EndPoints.API_PARTNER, FETCH_LIST_SUCCESS)

export const getPartner = (id) =>
  fetch(`${EndPoints.API_PARTNER}/${id}`, FETCH_PARTNER_SUCCESS)

export const createPartner = (formData) =>
  mutate(() => API.post(EndPoints.API_PARTNER, formData))

export const updatePartner = (id, formData) =>
  mutate(() => API.put(`${EndPoints.API_PARTNER}/${id}`, formData))

export const deactivatePartner = (id) =>
  mutate(() => API.delete(`${EndPoints.API_PARTNER}/${id}`))

export const restorePartner = (id) =>
  mutate(() => API.put(`${EndPoints.API_PARTNER}/${id}/restore`))

// ---------- push template ----------

export const getPushTemplateList = (partnerId) =>
  fetch(
    `${EndPoints.API_PARTNER}/${partnerId}/pushTemplates`,
    FETCH_PUSH_TEMPLATE_SUCCESS
  )

export const createPushTemplate = (data) =>
  mutate(() => API.post(`${EndPoints.API_PARTNER}/pushTemplate`, data))

export const updatePushTemplate = (id, data) =>
  mutate(() => API.put(`${EndPoints.API_PARTNER}/pushTemplate/${id}`, data))

export const deletePushTemplate = (id) =>
  mutate(() => API.delete(`${EndPoints.API_PARTNER}/pushTemplate/${id}`))

// ---------- helper ----------

export const getHelperList = (partnerId) =>
  fetch(`${EndPoints.API_PARTNER}/${partnerId}/helpers`, FETCH_HELPER_SUCCESS)

export const createHelper = (data) =>
  mutate(() => API.post(`${EndPoints.API_PARTNER}/helper`, data))

export const updateHelper = (id, data) =>
  mutate(() => API.put(`${EndPoints.API_PARTNER}/helper/${id}`, data))

export const deleteHelper = (id) =>
  mutate(() => API.delete(`${EndPoints.API_PARTNER}/helper/${id}`))
